import './typography-mapping.css';
export var MarkdownCheckmarkBackgroundCSS = '_11vdepp5-3-8-0';
export var MarkdownHeadingCSS = '_11vdepp0-3-8-0';
export var MarkdownImageCSS = '_11vdepp4-3-8-0';
export var MarkdownListCSS = '_11vdepp1-3-8-0';
export var MarkdownListItemCSS = '_11vdepp2-3-8-0';
export var MarkdownParagraphCSS = '_11vdepp3-3-8-0';